import { render, staticRenderFns } from "./Debts.vue?vue&type=template&id=055d505e&scoped=true&"
import script from "./Debts.vue?vue&type=script&lang=js&"
export * from "./Debts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d505e",
  null
  
)

export default component.exports